<template>
<main class="info">
  <div class="big-title">
    <router-link :to="{ name: 'home' }"><img src="@/assets/img/ba-logo.svg"></router-link>
    <div class="info-address bold" v-html="info.address"></div>
    <div class="info-contact bold" v-html="info.contact"></div>
  </div>
  <div class="info-text" v-html="info.text"></div>
  <div class="info-text" v-html="info.credits"></div>
</main>
</template>

<script>
import {
  mapState
} from 'vuex'
export default {
  name: 'info',
  metaInfo() {
    return {
      title: '– Info',
      meta: [{
        description: this.info.text
      }]
    }
  },
  computed: mapState(['info']),
}
</script>

<style lang="scss" scoped>
.info {
    padding-top: calc(3 * var(--lh)) !important;
    @media only screen and (max-width:1024px) {
        padding-top: calc(4 * var(--lh)) !important;
    }
    .big-title {
        position: relative;
        margin-bottom: calc(4 * var(--lh));
        width: 100%;
        @media only screen and (max-width:768px) {
            margin-bottom: 0;
        }
        a {
            display: inline-block;
            width: 100%;
        }
        img {
            width: 100%;
        }
        .info-address,
        .info-contact {
            position: absolute;
            top: calc(100% - (0.5 * var(--lh)));
            left: 8%;
            display: inline-block !important;
            width: auto;
            p {
                display: inline-block !important;
                width: auto;
            }
            @media only screen and (max-width:768px) {
                position: relative;
                top: auto;
                left: auto;
                width: 100%;
                transform: none;
                margin: var(--lh) 0 0;
            }
        }
        .info-contact {
            left: 54%;
            @media only screen and (max-width:768px) {
                left: auto;
            }
        }
    }
    .info-text {
        padding: calc(2 * var(--lh)) 20vw;
        @media only screen and (max-width:768px) {
            padding: var(--lh) 0 0;
        }
        p {
            display: inline-block !important;
            width: auto;
            font-size: var(--fs) !important;
            line-height: var(--lh) !important;
            // font-family: "SimilarBold", Helvetica, Arial, sans-serif !important;
        }
        &:last-of-type {
            padding-bottom: var(--lh);
        }
    }
}
</style>
